const $literal = (_obj, expr, _options) => expr;
export {
  $literal
};
